import React, { FC, useEffect } from 'react';
import { HomePublic } from './HomePublic';
import { SimpleHomePublic } from './SimpleHomePublic';
import { CommonApp } from '../common/components/common-app/CommonApp';
import { doctrineAnalytics } from '../utils/analyticsUtils';
import { cleanUrlFromParameters } from '../utils/url-utils/urlUtils';

export const HomePublicApp: FC = () => {
  useEffect(() => {
    cleanUrlFromParameters();
    window.onbeforeprint = function detectPrint() {
      doctrineAnalytics('Home BrowserPrinted', {
        trigger: 'onbeforeprint',
      });
    };
    if (window.matchMedia) {
      const mediaQueryList = window.matchMedia('print');
      mediaQueryList.addListener(mql => {
        if (mql.matches) {
          doctrineAnalytics('Home BrowserPrinted', {
            trigger: 'matchMedia',
          });
        }
      });
    }
  }, []);

  return (
    <CommonApp>
      <HomePublic />
      <SimpleHomePublic />
    </CommonApp>
  );
};
